import { cosmos, ethereum, iov, terra } from "./ledgers";

// Source: https://docs.tendermint.com/master/spec/blockchain/encoding.html
export const encodings = {
  PubKeySecp256k1: Buffer.from("EB5AE98721", "hex"),
};

export const coins = {
  ethereum: {
    coinNum: 60,
    accountNum: 0,
    changeNum: 0,
  },
  terra: {
    coinNum: 330, // terra-project/core.../types/util/hdpath.go
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "terrapub",
    hrpAddress: "terra",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  cosmos: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "cosmospub",
    hrpAddress: "cosmos",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  kava: {
    coinNum: 118, //459
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "kavapub",
    hrpAddress: "kava",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  band: {
    coinNum: 118, //494
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "bandpub",
    hrpAddress: "band",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  starname: {
    coinNum: 234,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "starpub",
    hrpAddress: "star",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  switcheo: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "swthpub",
    hrpAddress: "swth",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  persistence: {
    coinNum: 750,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "persistencepub",
    hrpAddress: "persistence",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  sentinel: {
    coinNum: 811,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "sentpub",
    hrpAddress: "sent",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  osmosis: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "osmopub",
    hrpAddress: "osmo",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  certik: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "certikpub",
    hrpAddress: "certik",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  juno: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "junopub",
    hrpAddress: "juno",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  comdex: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "comdexpub",
    hrpAddress: "comdex",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  lum: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "lumpub",
    hrpAddress: "lum",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  gbridge: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "gravitypub",
    hrpAddress: "gravity",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  evmos: {
    coinNum: 60,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "evmospub",
    hrpAddress: "evmos",
    pubKeyType: "ethermint/PubKeyEthSecp256k1",
    typeUrl: "/ethermint.crypto.v1.ethsecp256k1.PubKey",
    web3TypeUrl: "/ethermint.types.v1.ExtensionOptionsWeb3Tx",
    encoding: encodings.PubKeySecp256k1,
  },
  agoric: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "agoricpub",
    hrpAddress: "agoric",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  injective: {
    coinNum: 60,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "injpub",
    hrpAddress: "inj",
    pubKeyType: "injective/PubKeyEthSecp256k1",
    typeUrl: "/injective.crypto.v1beta1.ethsecp256k1.PubKey",
    web3TypeUrl: "/injective.types.v1beta1.ExtensionOptionsWeb3Tx",
    encoding: encodings.PubKeySecp256k1,
  },
  akash: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "akashpub",
    hrpAddress: "akash",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  sifchain: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "sifpub",
    hrpAddress: "sif",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  archway: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "archwaypub",
    hrpAddress: "archway",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  terrav2: {
    coinNum: 330,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "terrapub",
    hrpAddress: "terra",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  passage3d: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "pasgpub",
    hrpAddress: "pasg",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  quicksilver: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "quickpub",
    hrpAddress: "quick",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  kujira: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "kujirapub",
    hrpAddress: "kujira",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  celestia: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "celestiapub",
    hrpAddress: "celestia",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  dydx: {
    coinNum: 118,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "dydxpub",
    hrpAddress: "dydx",
    pubKeyType: "tendermint/PubKeySecp256k1",
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    encoding: encodings.PubKeySecp256k1,
  },
  dymension: {
    coinNum: 60,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "dympub",
    hrpAddress: "dym",
    pubKeyType: "ethermint/PubKeyEthSecp256k1",
    typeUrl: "/ethermint.crypto.v1.ethsecp256k1.PubKey",
    web3TypeUrl: "/ethermint.types.v1.ExtensionOptionsWeb3Tx",
    encoding: encodings.PubKeySecp256k1,
  },
  canto: {
    coinNum: 60,
    accountNum: 0,
    changeNum: 0,
    hrpPubKey: "cantopub",
    hrpAddress: "canto",
    pubKeyType: "ethermint/PubKeyEthSecp256k1",
    typeUrl: "/ethermint.crypto.v1.ethsecp256k1.PubKey",
    web3TypeUrl: "/ethermint.types.v1.ExtensionOptionsWeb3Tx",
    encoding: encodings.PubKeySecp256k1,
  },
};

export const ledgerApps = {
  ethereum,
  terra,
  cosmos,
  kava: cosmos,
  band: cosmos,
  starname: iov,
  switcheo: cosmos,
  persistence: cosmos,
  sentinel: cosmos,
  osmosis: cosmos,
  certik: cosmos,
  juno: cosmos,
  comdex: cosmos,
  lum: cosmos,
  gbridge: cosmos,
  agoric: cosmos,
  akash: cosmos,
  sifchain: cosmos,
  archway: cosmos,
  terrav2: terra,
  passage3d: cosmos,
  quicksilver: cosmos,
  kujira: cosmos,
  celestia: cosmos,
  dydx: cosmos,
};

export const ledgerHDPaths = {
  ethereum: [
    {
      name: "Ledger Live",
      ledgerAppName: "Ethereum App",
      path: `m/44'/60'/{accountNum}'/0/{addressIdx}`,
      app: "ethereum",
    },
    {
      name: "Legacy (MEW / MyCrypto)",
      ledgerAppName: "Ethereum App",
      path: `m/44'/60'/0'/{accountNum}`,
      app: "ethereum",
    },
  ],
  terra: [
    {
      name: "Terra App",
      path: `m/44'/330'/{accountNum}'/0/{addressIdx}`,
      app: "terra",
    },
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  cosmos: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  kava: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  band: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  starname: [
    {
      name: "IOV App",
      path: `m/44'/234'/{accountNum}'/0/{addressIdx}`,
      app: "starname",
    },
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  switcheo: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  persistence: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  sentinel: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  osmosis: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  certik: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  juno: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  comdex: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  lum: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  gbridge: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  agoric: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  akash: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  sifchain: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  archway: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  terrav2: [
    {
      name: "Terra App",
      path: `m/44'/330'/{accountNum}'/0/{addressIdx}`,
      app: "terra",
    },
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  passage3d: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  quicksilver: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  kujira: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  celestia: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
  dydx: [
    {
      name: "Cosmos App",
      path: `m/44'/118'/{accountNum}'/0/{addressIdx}`,
      app: "cosmos",
    },
  ],
};
